/* eslint-disable @typescript-eslint/naming-convention */
import { Injectable } from '@angular/core';
import { CoreDataService } from '@app/core/async-services/http/core.data';
import { PushNotificationsService } from '@app/core/services/push-notifications/push-notifications.service';

interface BindingResponse {
  message: string;
}

@Injectable({ providedIn: 'root' })
export class NotificationService {
  constructor(
    private coreDataService: CoreDataService,
    private pushNotificationsService: PushNotificationsService,
  ) {}

  async createBinding(): Promise<void> {
    const token = await this.pushNotificationsService.getToken();
    this.coreDataService
      .post<BindingResponse>('v1/notification/binding/create', {
        token,
      })
      .subscribe((response) => {
        console.log('createBinding response: ', response);
      });
  }
}
